// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tag-selector-count{flex:0 0 30px;height:30px;background-color:#07070e;border-radius:50%;text-align:center;line-height:30px;font-weight:900;user-select:none;color:#00a3ff;font-size:13px}", ""]);
// Exports
module.exports = exports;
